<template>
  <div id="login-main">
    <router-view></router-view>
    <!-- /.login-box-body -->
  </div>
</template>

<script>
export default {
  mounted() {
    const array = ["background-1", "background-2"];
    let background = array[Math.floor(Math.random() * array.length)];
    document.body.className = `hold-transition login-page ${background}`;
    // document.body.removeAttribute("style")
    document.querySelector("#login-main").parentElement.className = "login-box";
  },
  destroyed() {
    document.querySelector("#main").className = "";
  },
};
</script>

<style lang="scss">
.login-box {
  position: relative;
  height: 500px;
}
.background-1 {
  background-image: url("/resources/img/BC-FONDOS-01.jpg");
}
.background-2 {
  background-image: url("/resources/img/BC-FONDOS-02.jpg");
}
</style>
